import {
  Box,
  Button,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  FormControl,
  FormLabel,
  Text,
  VStack,
} from '@chakra-ui/react'
import { Dialog, DialogTrigger } from '@radix-ui/react-dialog'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

import {
  DialogDrawer,
  useDialogContext,
} from '@/components/shared/bundles/Drawer'
import { Inputs } from '@/components/shared/forms/Inputs'
import { PageHeader } from '@/components/shared/navigation/PageHeader'
import { useAuthStore } from '@/features/sessao/store/useAuthStore'
import { Repository } from '@/services/repository'

const ResetPasswordDialog = () => {
  const { user } = useAuthStore()
  const { onClose } = useDialogContext()

  const form = useForm({
    defaultValues: {
      password: '',
      confirmPassword: '',
    },
  })

  const onSubmit = form.handleSubmit(async (data) => {
    if (!user) return toast.error('Usuário não encontrado')

    const { password, confirmPassword } = data
    if (password !== confirmPassword) return toast.error('Senhas não conferem')

    try {
      await Repository.Entity.User.ChangePassword({
        id: user.id,
        password: data.password,
      })
      toast.success('Senha alterada com sucesso')
      onClose()
    } catch (error: any) {
      toast.error(error.message)
    }
  })

  return (
    <DialogDrawer>
      <form onSubmit={onSubmit}>
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Reiniciar senha</DrawerHeader>
          <DrawerBody>
            <VStack align="stretch" gap={4}>
              <FormControl>
                <FormLabel>Nova senha</FormLabel>
                <Inputs.Password useForm={form} useFormField="password" />
              </FormControl>

              <FormControl>
                <FormLabel>Confirmar nova senha</FormLabel>
                <Inputs.Password
                  useForm={form}
                  useFormField="confirmPassword"
                />
              </FormControl>
            </VStack>
          </DrawerBody>

          <DrawerFooter>
            <Button type="submit" colorScheme="primary">
              Enviar
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </form>
    </DialogDrawer>
  )
}

export default function Component() {
  const { user } = useAuthStore()

  return (
    <>
      <PageHeader title="Minha página" />
      <Box p={8}>
        <Text fontSize="xl" mb={8}>
          Bem-vindo {user?.displayName}
        </Text>
        <Dialog>
          <DialogTrigger>
            <Button colorScheme="primary">Alterar senha</Button>
          </DialogTrigger>
          <ResetPasswordDialog />
        </Dialog>
      </Box>
    </>
  )
}
